import { ImageAtoms, Button } from '@vfit/shared/atoms';
import { ISummary } from './summary.models';
import {
  Container,
  Title,
  Description,
  InnerContainer,
  DivImgContainer,
  ButtonContainer,
} from './summary.style';
import { checkIsApp } from '@vfit/consumer/data-access';
import { getVariantByActionStyle, trackLink, trackView } from '@vfit/shared/data-access';
import { useEffect } from 'react';

const Summary = ({ summaryConfig, setModal, handleSubmit, isLoading, codeFiscal }: ISummary) => {
  const { title, message, imageSrc, primaryButton, secondaryButton } = summaryConfig || {};
  const updatedMessage =
  message?.replace('$FISCAL_CODE', `<strong>${codeFiscal || ''}</strong>`) || '';
  
  useEffect(() => {
      trackView({
        event_label_track: 'form typ',
        event_name:  ["view"],
        journey_name: window['utag_data']?.journey_name || 'dynamic form',
        journey_type: window['utag_data']?.journey_type || 'journey',
        page_section: window['utag_data']?.page_section || 'dynamic form',
        page_subsection: window['utag_data']?.page_subsection || undefined,
      });
    }, []);

  const submit = () => {
    trackLink(primaryButton?.title || 'CONFERMA e procedi');
    handleSubmit()
  };

  const closeModal = () => {
    trackLink(secondaryButton?.title || 'ANNULLA');
    setModal({ show: false });
  }
  return (
    <Container>
      <DivImgContainer>
        <ImageAtoms nameCard="check" image={imageSrc} alt="check icon" />
      </DivImgContainer>
      <InnerContainer>
        <Title>{title || 'Ci siamo quasi!'}</Title>
      </InnerContainer>

      <Description dangerouslySetInnerHTML={{ __html: updatedMessage }} />
      <ButtonContainer>
        <Button
          onClick={submit}
          name="action_retrieveFiscalCode"
          variant={checkIsApp() ? 'mva:primary' : getVariantByActionStyle(primaryButton?.style)}
          loading={isLoading}
          disabled={isLoading}
          aria-label={primaryButton?.title}
        >
          {primaryButton?.title || 'CONFERMA e procedi'}
        </Button>
        <Button
          onClick={closeModal}
          name="action_returnToForm"
          variant={checkIsApp() ? 'secondary' : getVariantByActionStyle(secondaryButton?.style)}
          loading={isLoading}
          disabled={isLoading}
          aria-label={secondaryButton?.title}
        >
          {secondaryButton?.title || 'ANNULLA'}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default Summary;

